export default __webpack_public_path__ + "static/media/logo-vermelha.544df6e2.png";